// extracted by mini-css-extract-plugin
module.exports = {"gray-30":"_2zUcKN","brand-30":"_1GPPMw","shine-lines":"_2HutWT"};